// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3Sv5g","label":"Radio_label__3Xhjr","checkMark":"Radio_checkMark__ZQBK8","disabled":"Radio_disabled__aSrYu"};